<template>
  <div>
    <confirm-dialog ref="confirm">
      <v-row slot="action" no-gutters>
        <v-spacer></v-spacer>
        <v-btn color="darkColor" small ref="yes" rounded class="normal-letter-spacing px-12 py-4 ml-2"
          style="color: white" @click="confirmDialogConfirmFunction()" :disabled="disabelConfirm">
          بله
        </v-btn>
        <v-btn small rounded text ref="no" class="normal-letter-spacing px-12 confirm-cancel-btn"
          @click="confirmDialogCancelFunction()">
          خیر
        </v-btn>
      </v-row>
    </confirm-dialog>
    <v-dialog v-model="resultDialog" width="500" persistent>
      <v-card>
        <v-row no-gutters>
          <v-col cols="12" class="modal-header py-2">
            <v-row no-gutters>
              <v-spacer></v-spacer>
              <v-icon color="darkColor">mdi-plus</v-icon>
              <span class="modal-title-text mr-2">نتیجه</span>
              <v-spacer></v-spacer>
            </v-row>
          </v-col>
        </v-row>
        <v-card-text>
          <v-row>
            <v-col cols="12" class="mt-6">
              <v-autocomplete :items="withOutPatientResultList" no-data-text="اطلاعاتی وجود ندارد" dense outlined
                clearable v-model="withOutPatientResult" clear-icon="mdi-close-circle-outline" item-text="title"
                item-value="id" label="نتیجه" autocomplete="off"
                prepend-inner-icon="mdi-text-box mdi-18px"></v-autocomplete>
            </v-col>
            <v-col cols="12" v-if="withOutPatientResult == 6">
              <v-textarea dense outlined rows="4" clearable v-model="withOutPatientResultNote"
                clear-icon="mdi-close-circle-outline" label="توضیحات" autocomplete="off"
                prepend-inner-icon="mdi-text mdi-18px"></v-textarea>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions class="mt-2">
          <v-spacer></v-spacer>
          <v-btn color="darkColor" @click="setMissionWithOutPatient()" dark rounded class="normal-letter-spacing px-12">
            تایید
          </v-btn>
          <v-btn rounded color="darkColor" outlined @click="cancelSetMissionWithOutPatient()"
            class="normal-letter-spacing px-10">
            انصراف
          </v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="technesianModal" width="800" persistent>
      <v-card>
        <v-row no-gutters>
          <v-col cols="12" class="modal-header py-3">
            <v-row no-gutters>
              <v-spacer></v-spacer>
              <v-icon color="darkColor">mdi-plus</v-icon>
              <span class="modal-title-text mr-2">انتخاب تکنسین {{ technesianModalTitle }}</span>
              <v-spacer></v-spacer>
            </v-row>
          </v-col>
        </v-row>
        <v-card-text>
          <v-row>
            <v-col cols="12" class="mt-3">
              <v-text-field v-model="searchTextTechnisian" dense outlined prepend-inner-icon="mdi-magnify mdi-18px"
                rounded label="جستجو"></v-text-field>
            </v-col>
            <v-col cols="12" class="mt-n5">
              <template>
                <v-data-table :headers="technesianTableHeaders" :items="technesiansList"
                  :items-per-page="technesiansList.length" height="37vh" v-model="selectedTechnesian" item-key="id"
                  show-select :search="searchTextTechnisian" :hide-default-footer="true" single-select multi-sort
                  class="elevation-0">
                  <template v-slot:no-data>
                    <span>اطلاعاتی جهت نمایش وجود ندارد</span>
                  </template>
                </v-data-table>
              </template>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions class="mt-2">
          <v-spacer></v-spacer>
          <v-btn color="darkColor" @click="setTechnecian()" dark rounded class="normal-letter-spacing px-12">
            افزودن
          </v-btn>
          <v-btn rounded color="darkColor" outlined @click="cancelTechnecian()" class="normal-letter-spacing px-10">
            انصراف
          </v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-row no-gutters>
      <v-col cols="12" class="mr-2 mt-4">
        <v-row>
          <v-col cols="9">
            <v-card elevation="0" height="90vh" class="follow-up-main-card">
              <v-card-text>
                <v-row class="">
                  <v-col cols="2" class="covered-position">
                    <span class="current-mission-header-content">اطلاعات ماموریت</span>
                  </v-col>
                </v-row>
                <v-row no-gutters>
                  <v-col cols="12" class="body-part">
                    <v-row class="mt-2">
                      <span class="mr-2">زمان ها</span>
                      <v-divider class="mt-3 mr-2"></v-divider>
                    </v-row>
                    <v-row>
                      <v-col cols="4">
                        <app-date-picker :input-i-d="'disp-1'" :const-value="dispatchTime" input-id="recieveMissionTime"
                          label="ابلاغ ماموریت" :disabled="true" />
                      </v-col>
                      <v-col cols="4">
                        <v-text-field type="text" outlined id="user-moveFromStationTime" ref="moveFromStationTime" dense
                          clearable autocomplete="off" @click:clear="clearDateTime('moveFromStationTime')"
                          clear-icon="mdi-close-circle-outline" v-model="tempMoveFromStationTime"
                          @focus="showMoveFromStationTime = true" @click="showMoveFromStationTime = true"
                          label="حرکت از پایگاه" prepend-inner-icon="mdi-calendar-range mdi-18px"
                          :disabled="haveMoveFromStationTime">
                          <template slot="append" v-if="!haveMoveFromStationTime">
                            <v-icon @click="showMoveFromStationTime = true" class="calender-background ml-n3 mt-n2"
                              color="white">
                              mdi-calendar-range mdi-18px
                            </v-icon>
                          </template>
                        </v-text-field>
                        <date-picker :max="maxDateTime" :min="minDateTime" :disabled="haveMoveFromStationTime"
                          :show="showMoveFromStationTime" simple v-model="moveFromStationTime" type="datetime"
                          @open="onOpen" @change="dateTimeChange('moveFromStationTime')" :editable="true"
                          format="YYYY-MM-DDTHH:mm:ss" display-format="HH:mm:ss jYYYY/jMM/jDD"
                          custom-input="#moveFromStationTime-moveFromStationTime"
                          @close="showMoveFromStationTime = false" />
                      </v-col>
                      <v-col cols="4">
                        <v-text-field type="text" outlined id="user-arriveToLocationTime" ref="arriveToLocationTime"
                          dense autocomplete="off" clearable @click:clear="clearDateTime('arriveToLocationTime')"
                          clear-icon="mdi-close-circle-outline" v-model="tempArriveToLocationTime"
                          @focus="showArriveToLocationTime = true" @click="showArriveToLocationTime = true"
                          label="رسیدن به فوریت" prepend-inner-icon="mdi-calendar-range mdi-18px"
                          :disabled="haveArriveToLocationTime">
                          <template slot="append" v-if="!haveArriveToLocationTime">
                            <v-icon @click="showArriveToLocationTime = true" class="calender-background ml-n3 mt-n2"
                              color="white">
                              mdi-calendar-range mdi-18px
                            </v-icon>
                          </template>
                        </v-text-field>
                        <date-picker :max="maxDateTime" :min="minDateTime" :disabled="haveArriveToLocationTime"
                          :show="showArriveToLocationTime" simple type="datetime" @open="onOpen"
                          v-model="arriveToLocationTime" @change="dateTimeChange('arriveToLocationTime')"
                          :editable="true" format="YYYY-MM-DDTHH:mm:ss" display-format="HH:mm:ss jYYYY/jMM/jDD"
                          custom-input="#arriveToLocationTime-arriveToLocationTime"
                          @close="showArriveToLocationTime = false" />
                      </v-col>
                      <v-col cols="4" class="mt-n8">
                        <v-text-field type="text" outlined id="user-moveFromLocationTime" autocomplete="off"
                          ref="moveFromLocationTime" dense clearable
                          @click:clear="clearDateTime('moveFromLocationTime')" clear-icon="mdi-close-circle-outline"
                          v-model="tempMoveFromLocationTime" @focus="showMoveFromLocationTime = true"
                          @click="showMoveFromLocationTime = true" label="حرکت از فوریت"
                          prepend-inner-icon="mdi-calendar-range mdi-18px" :disabled="haveMoveFromLocationTime">
                          <template slot="append" v-if="!haveMoveFromLocationTime">
                            <v-icon @click="showMoveFromLocationTime = true" class="calender-background ml-n3 mt-n2"
                              color="white">
                              mdi-calendar-range mdi-18px
                            </v-icon>
                          </template>
                        </v-text-field>
                        <date-picker :max="maxDateTime" :min="minDateTime" :disabled="haveMoveFromLocationTime"
                          :show="showMoveFromLocationTime" simple type="datetime" v-model="moveFromLocationTime"
                          @change="dateTimeChange('moveFromLocationTime')" :editable="true" @open="onOpen"
                          format="YYYY-MM-DDTHH:mm:ss" display-format="HH:mm:ss jYYYY/jMM/jDD"
                          custom-input="#user-moveFromLocationTime" @close="showMoveFromLocationTime = false" />
                      </v-col>
                      <v-col cols="4" class="mt-n8">
                        <v-text-field type="text" outlined id="user-arriveToHospitalTime" ref="arriveToHospitalTime"
                          autocomplete="off" dense clearable @click:clear="clearDateTime('arriveToHospitalTime')"
                          clear-icon="mdi-close-circle-outline" v-model="tempArriveToHospitalTime"
                          @focus="showArriveToHospitalTime = true" @click="showArriveToHospitalTime = true"
                          label="رسیدن به مرکز درمانی" prepend-inner-icon="mdi-calendar-range mdi-18px"
                          :disabled="haveArriveToHospitalTime">
                          <template slot="append" v-if="!haveArriveToHospitalTime">
                            <v-icon @click="showArriveToHospitalTime = true" class="calender-background ml-n3 mt-n2"
                              color="white">
                              mdi-calendar-range mdi-18px
                            </v-icon>
                          </template>
                        </v-text-field>
                        <date-picker :max="maxDateTime" :min="minDateTime" :disabled="haveArriveToHospitalTime"
                          :show="showArriveToHospitalTime" simple type="datetime" v-model="arriveToHospitalTime"
                          @change="dateTimeChange('arriveToHospitalTime')" :editable="true" @open="onOpen"
                          format="YYYY-MM-DDTHH:mm:ss" display-format="HH:mm:ss jYYYY/jMM/jDD"
                          custom-input="#user-arriveToHospitalTime" @close="showArriveToHospitalTime = false" />
                      </v-col>
                      <v-col cols="4" class="mt-n8">
                        <v-text-field type="text" outlined id="user-patientDeliveryTime" ref="patientDeliveryTime" dense
                          clearable autocomplete="off" @click:clear="clearDateTime('patientDeliveryTime')"
                          clear-icon="mdi-close-circle-outline" v-model="tempPatientDeliveryTime"
                          @focus="showPatientDeliveryTime = true" @click="showPatientDeliveryTime = true"
                          label="تحویل به مرکز درمانی" prepend-inner-icon="mdi-calendar-range mdi-18px"
                          :disabled="havePatientDeliveryTime">
                          <template slot="append" v-if="!havePatientDeliveryTime">
                            <v-icon @click="showPatientDeliveryTime = true" class="calender-background ml-n3 mt-n2"
                              color="white">
                              mdi-calendar-range mdi-18px
                            </v-icon>
                          </template>
                        </v-text-field>
                        <date-picker :max="maxDateTime" :min="minDateTime" :disabled="havePatientDeliveryTime"
                          :show="showPatientDeliveryTime" simple type="datetime" v-model="patientDeliveryTime"
                          @change="dateTimeChange('patientDeliveryTime')" :editable="true" @open="onOpen"
                          format="YYYY-MM-DDTHH:mm:ss" display-format="HH:mm:ss jYYYY/jMM/jDD"
                          custom-input="#user-patientDeliveryTime" @close="showPatientDeliveryTime = false" />
                      </v-col>
                      <v-col cols="4" class="mt-n8">
                        <v-text-field type="text" outlined id="user-finishTime" ref="finishTime" autocomplete="off"
                          dense clearable @click:clear="clearDateTime('finishTime')"
                          clear-icon="mdi-close-circle-outline" v-model="tempFinishTime" @focus="showFinishTime = true"
                          @click="showFinishTime = true" label="پایان ماموریت"
                          prepend-inner-icon="mdi-calendar-range mdi-18px" :disabled="haveFinishTime">
                          <template slot="append" v-if="!haveFinishTime">
                            <v-icon @click="showFinishTime = true" class="calender-background ml-n3 mt-n2"
                              color="white">
                              mdi-calendar-range mdi-18px
                            </v-icon>
                          </template>
                        </v-text-field>
                        <date-picker :max="maxDateTime" :min="minDateTime" :disabled="haveFinishTime"
                          :show="showFinishTime" simple type="datetime" v-model="finishTime" @open="onOpen"
                          @change="dateTimeChange('finishTime')" :editable="true" format="YYYY-MM-DDTHH:mm:ss"
                          display-format="HH:mm:ss jYYYY/jMM/jDD" custom-input="#user-finishTime"
                          @close="showFinishTime = false" />
                      </v-col>
                      <v-col cols="4" class="mt-n8">
                        <v-text-field type="text" outlined id="user-arriveToStationTime" ref="arriveToStationTime" dense
                          autocomplete="off" clearable @click:clear="clearDateTime('arriveToStationTime')"
                          clear-icon="mdi-close-circle-outline" v-model="tempArriveToStationTime"
                          @focus="showArriveToStationTime = true" @click="showArriveToStationTime = true"
                          label="رسیدن به پایگاه" prepend-inner-icon="mdi-calendar-range mdi-18px"
                          :disabled="haveArriveToStationTime">
                          <template slot="append" v-if="!haveArriveToStationTime">
                            <v-icon @click="showArriveToStationTime = true" class="calender-background ml-n3 mt-n2"
                              color="white">
                              mdi-calendar-range mdi-18px
                            </v-icon>
                          </template>
                        </v-text-field>
                        <date-picker :max="maxDateTime" :min="minDateTime" :disabled="haveArriveToStationTime"
                          :show="showArriveToStationTime" simple type="datetime" v-model="arriveToStationTime"
                          @change="dateTimeChange('arriveToStationTime')" :editable="true" @open="onOpen"
                          format="YYYY-MM-DDTHH:mm:ss" display-format="HH:mm:ss jYYYY/jMM/jDD"
                          custom-input="#user-arriveToStationTime" @close="showArriveToStationTime = false" />
                      </v-col>
                    </v-row>
                    <v-row class="mt-n4">
                      <span class="mr-2">کیلومتر ها</span>
                      <v-divider class="mt-3 mr-2"></v-divider>
                    </v-row>
                    <v-row>
                      <v-col cols="4">
                        <v-text-field dense outlined @keypress="isNumber($event)" v-model="moveFromStationKM"
                          label="کیلومتر حرکت از پایگاه" clearable clear-icon="mdi-close-circle-outline"
                          prepend-inner-icon="mdi-speedometer mdi-18px"></v-text-field>
                      </v-col>
                      <v-col cols="4">
                        <v-text-field dense outlined v-model="finishKM" @keypress="isNumber($event)"
                          label="کیلومتر پایان ماموریت" clearable clear-icon="mdi-close-circle-outline"
                          prepend-inner-icon="mdi-speedometer mdi-18px"></v-text-field>
                      </v-col>
                      <v-col cols="4">
                        <v-text-field dense outlined v-model="arriveToStationKM" @keypress="isNumber($event)"
                          label="کیلومتر رسیدن به پایگاه" clearable clear-icon="mdi-close-circle-outline"
                          prepend-inner-icon="mdi-speedometer mdi-18px"></v-text-field>
                      </v-col>
                    </v-row>
                    <v-row class="mt-n4">
                      <span class="mr-2">تکنسین ها</span>
                      <v-divider class="mt-3 mr-2"></v-divider>
                      <v-btn color="darkColor" small @click="showTechnesianModal(1)" elevation="0"
                        class="mt-n2 py-3 mr-5">
                        <v-icon color="white" size="16px">mdi-plus</v-icon>
                        <span class=" mr-2" style="color: white;"> افزودن تکنسین</span>
                      </v-btn>
                    </v-row>
                    <div class="technecianListBox">
                      <div class="itemTechnecian" v-for="(i, index) in userIds_Show" :key="index">
                        <span>تکنسین {{ index == 0 ? 'ارشد' : index + 1 }} : </span>
                        <span>{{ i?.name }}</span>
                        <v-icon color="darkColor" size="18px" @click="removeSelectedTechnecian(i?.id)">
                          mdi-close-circle
                        </v-icon>
                      </div>
                      <v-col cols="12" v-if="userIds_Show?.length == 0" class="mt-8 textNoItem">
                        <span>لیست تکنسین خالی می باشد</span>
                      </v-col>
                    </div>
                    <v-row class="mt-n4 mb-3">
                      <span class="mr-2">اطلاعات محل ماموریت</span>
                      <v-divider class="mt-3"></v-divider>
                    </v-row>
                    <v-row>
                      <v-col cols="6">
                        <v-row>
                          <v-col cols="6">
                            <v-autocomplete hide-details dense outlined no-data-text="اطلاعاتی وجود ندارد"
                              clear-icon="mdi-close-circle-outline" item-text="title" item-value="title"
                              prepend-inner-icon="mdi-road-variant mdi-18px" label="نوع ماموریت"
                              :items="missionTypesList" v-model="missionLocationInfo.missionPlaceType"></v-autocomplete>
                          </v-col>
                          <v-col cols="6">
                            <v-autocomplete hide-details dense outlined no-data-text="اطلاعاتی وجود ندارد"
                              clear-icon="mdi-close-circle-outline" item-text="title" item-value="value"
                              prepend-inner-icon="mdi-road-variant mdi-18px" label="آیا صحنه ایمن است؟"
                              :items="missionSecurityTypesList"
                              v-model="missionLocationInfo.isPlaceSecure"></v-autocomplete>
                          </v-col>
                        </v-row>
                      </v-col>
                      <v-col cols="6">
                        <v-textarea hide-details dense outlined label="توضیحات" :rows="1"
                          v-model="missionLocationInfo.placeDescription"></v-textarea>
                      </v-col>
                    </v-row>
                    <div no-gutters class="d-flex gap-2 mt-3">
                      <recursive-field v-bind="fieldsData" global-field-name="placeCategory" :level="0" :cols="4" />
                    </div>
                    <!-- <v-row>
                    </v-row> -->
                    <v-row class="mt-5">
                      <v-spacer></v-spacer>
                      <v-btn color="darkColor" @click="setMissionInfo()" dark rounded class="px-11 ml-5">
                        ثبت
                      </v-btn>
                      <v-btn color="darkColor" dark rounded @click="cancleSetMission()" outlined class="px-8 ml-3">
                        انصراف
                      </v-btn>
                    </v-row>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col cols="3">
            <v-row no-gutters>
              <app-titled-box title="مددجویان" class="section-box">
                <v-row no-gutters class="patient-list-container">
                  <v-col cols="12" v-for="(item, index) in patientList" :key="item.id" class="py-2">
                    <div class="items-back"></div>
                    <v-row no-gutters>
                      <v-col cols="1"></v-col>
                      <v-col cols="11">
                        <v-card height="8vh" class="mt-4 mr-2">
                          <v-row no-gutters>
                            <v-col cols="2">
                              <v-row class="items-space" no-gutters></v-row>
                              <v-row no-gutters>
                                <v-col cols="12" class="items-circle">
                                  <v-row class="items-space-above" no-gutters></v-row>
                                  <v-row no-gutters>
                                    <v-col cols="8" class="items-circle-above">
                                      <v-row no-gutters>
                                        <v-col cols="12" class="text-center items-index-space">
                                          <span class="items-index">{{ index + 1 }}</span>
                                        </v-col>
                                      </v-row>
                                    </v-col>
                                    <v-spacer></v-spacer>
                                  </v-row>
                                </v-col>
                              </v-row>
                            </v-col>
                            <v-col cols="7" class="items-card-text-space">
                              <span>
                                {{ item.firstName ? item.firstName : '-' }}
                                {{ item.lastName ? item.lastName : '-' }}
                              </span>
                            </v-col>
                            <v-col cols="1" class="items-card-text-space">
                              <v-tooltip top>
                                <template v-slot:activator="{ on, attrs }">
                                  <v-icon color="darkColor" style="cursor: pointer" @click="goToPatient(item.id)"
                                    v-bind="attrs" v-on="on">
                                    mdi-pencil mdi-24px
                                  </v-icon>
                                </template>
                                <span>ویرایش</span>
                              </v-tooltip>
                            </v-col>
                            <v-col cols="1" class="ml-3 items-card-text-space">
                              <v-tooltip top>
                                <template v-slot:activator="{ on, attrs }">
                                  <v-icon color="darkColor" style="cursor: pointer" class="mr-3"
                                    @click="showDeleteConfirmFunction(item.id)" v-bind="attrs" v-on="on">
                                    mdi-delete mdi-24px
                                  </v-icon>
                                </template>
                                <span>حذف</span>
                              </v-tooltip>
                            </v-col>
                          </v-row>
                        </v-card>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
                <v-row no-gutters class="patient-list-actions-container">
                  <v-col cols="12" class="mb-2">
                    <v-btn block outlined @click="goToPatient(null)" color="darkColor" rounded elevation="0">
                      <v-icon>mdi-plus</v-icon>
                      افزودن مددجو
                    </v-btn>
                  </v-col>
                  <v-col cols="12" class="mb-2">
                    <v-btn block :disabled="withOutPatientFlag" class="with-out-patient-btn" rounded
                      @click="showResultDialog()" elevation="0">
                      ثبت نهایی بدون مددجو
                    </v-btn>
                  </v-col>
                  <v-col cols="12">
                    <v-btn block dark color="darkColor" rounded elevation="0"
                      @click="finishMissionByFollowUpFunction()">
                      ثبت نهایی
                    </v-btn>
                  </v-col>
                </v-row>
              </app-titled-box>
            </v-row>
            <!-- </v-card-text>
            </v-card> -->
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <alert-component ref="snackRef" :snakTimeOut="snakTimeOut" :snackColor="snackColor" :snackText="snackText"
      :snakIcon="snakIcon"></alert-component>
  </div>
</template>
<script>
import CryptoJS from 'crypto-js';
import FollowUpMissionTypeFieldHelper from '@/Helpers/FollowUp/FollowUpMissionTypeField.helper';
import AlertComponent from '@/components/AlertComponent.vue';
import RecursiveField from '@/components/FollowUp/followupMission/RecursiveField.vue';
import confirmDialog from '@/components/ConfirmDialog.vue';
import AppTitledBox from '@/components/app/titledBox.vue';
import snackBar from '@/Mixins/snackBar.js';
import SharedHelper from '@/Helpers/Shared.js';
import FollowUpMissionHelper from '@/Helpers/FollowUp/FollowUpMissionHelper.js';
import AppDatePicker from '@/components/app/DatePicker.vue';
import UserMixin from '@/Mixins/BaseInformation/UserMixin.js';
import ShearedMixin from '@/Mixins/Shared.js';
import MissionPhonesMixin from '@/Mixins/Mission/MissionPhonesMixin';
import PatientMixin from '@/Mixins/Doctor/PatientMixin';
import moment from 'moment';
export default {
  name: 'FollowUpMission',
  title: 'اطلاعات ماموریت پیگیری',
  inject: ['load'],
  components: {
    AlertComponent,
    confirmDialog,
    AppDatePicker,
    AppTitledBox,
    RecursiveField,
  },
  mixins: [
    FollowUpMissionHelper,
    SharedHelper,
    UserMixin,
    snackBar,
    ShearedMixin,
    MissionPhonesMixin,
    PatientMixin,
    FollowUpMissionTypeFieldHelper,
  ],
  created() {
    this.$root.$refs.FollowUpMission = this;
  },
  mounted() {
    this.mounteLoding();
  },
  data() { return {}; },
  computed: {
    minDateTime() {
      if (this.dispatchTime) {
        return moment(this.dispatchTime).add(1, 'minute').format('YYYY-MM-DDTHH:mm:ss');
      }
      return moment().subtract(1, 'week').format('YYYY-MM-DDTHH:mm:ss');
    },
    maxDateTime() {
      return moment().format('YYYY-MM-DDTHH:mm:ss');
    }
  },
  methods: {
    mounte: function () {
      let id = this.$route.params.id;
      let bytes = CryptoJS.AES.decrypt(id, 'f9rr5r2Dfr7lyf8N');
      let missionPhoneId = '';
      if (bytes.sigBytes != 0) {
        missionPhoneId = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
      } else {
        missionPhoneId = '';
      }
      this.missionPhoneId = missionPhoneId;
      this.getMissionDataByfollowUpFunction(Number(this.missionPhoneId));
    },
  },
};
</script>
<style scoped>
.confirm-cancel-btn {
  border: solid 1px var(--dark-color);
  padding-top: 13px;
  padding-bottom: 15px;
  color: var(--dark-color);
}

.follow-up-main-card {
  border: 1px solid var(--dark-color) !important;
  border-radius: 10px !important;
  overflow-y: auto;
}

.follow-up-main-card2 {
  overflow-y: auto;
}

.current-mission-header {
  position: fixed;
  top: 5vh;
  width: 300px;
  height: 100px;
  z-index: 2;
}

.current-mission-header-content {
  color: var(--dark-color) !important;
  background-image: linear-gradient(to bottom, var(--background-color) 50%, white 50%);
  padding-right: 20px !important;
  padding-left: 20px !important;
}

.covered-position {
  margin-top: -3.5vh !important;
}

.body-part {
  height: 85vh !important;
}

.section-box {
  position: relative;
  border: 1px solid var(--dark-color);
}

.patient-list-container {
  position: relative;
  height: calc(83vh - 125px);
  overflow-y: auto;
  display: flex;
  gap: 0.5rem;
  padding: 0.5rem;
}

.patient-list-actions-container {
  position: sticky;
  background-color: white;
  bottom: 0;
  padding: 0.5rem 0;
  width: max-content;
  height: max-content;
  z-index: 200;
  padding: 0.5rem;
}

.calender-background {
  background: #79747e;
  padding-left: 12px;
  padding-right: 12px;
  padding-top: 12px;
  padding-bottom: 12px;
  border-top-left-radius: 5px !important;
  border-bottom-left-radius: 5px !important;
}

.with-out-patient-btn {
  background-color: var(--background-color) !important;
  color: var(--dark-color) !important;
}

.items-back {
  background: var(--dark-color) !important;
  position: absolute;
  height: 13vh;
  width: 45%;
  border-radius: 14px !important;
}

.items-circle {
  width: 4vh;
  height: 5vh;
  border-radius: 50% !important;
  background: white;
  margin-right: -2vh;
}

.items-space {
  height: 1.5vh;
}

.items-circle-above {
  width: 1.5vh;
  height: 4vh;
  border-radius: 50% !important;
  background: var(--dark-color);
  margin-right: 0.8vh;
  box-shadow: 0 3px 5px -1px rgba(0, 0, 0, 0.2), 0 5px 8px 0 rgba(0, 0, 0, 0.14),
    0 1px 14px 0 rgba(0, 0, 0, 0.12) !important;
}

.items-space-above {
  height: 0.5vh;
}

.items-index {
  color: white;
}

.items-index-space {
  margin-top: 0.7vh !important;
}

.items-card-text-space {
  margin-top: 3vh;
}

.technecianListBox {
  min-height: 80px !important;
  padding: 30px 0;
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-items: center;
  gap: 10px;
  row-gap: 15px;
}

.technecianListBox .itemTechnecian {
  border: 1px solid #00023578;
  border-radius: 8px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 5px;
  width: fit-content;
  padding: 8px 10px;
}

.textNoItem {
  text-align: center;
  margin-top: 20px;
}
</style>
